import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'tooltip-inner',
  templateUrl: 'tooltip-inner.component.html',
  styleUrls: ['tooltip-inner.component.scss'],
})
export class TooltipInnerComponent {
  @Input() tooltipText: string;
  @Input() arrowPosition: string = 'bottom-right'; // bottom-right/top-left
}
